import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { IProformaResponse } from 'utils/hooks/http/proforma.http';
import './OrderModal.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { set } from 'lodash';
import IconItem from 'components/Item/IconItem/IconItem';

type Props = {
  data?: IProformaResponse;
  handleCloseModal: () => void
  isDirectorCommercial?: boolean
  onConfirmOrder?: () => void
  loading?: boolean

}

const OrderModal: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const { user } = useSelector((state: RootState) => state.userData);

  const [retryCount, setRetryCount] = useState(3);

  const handleRetry = () => {
    if (retryCount === 0) {

      props.handleCloseModal();

      return;
    }


    if (props.onConfirmOrder) {

      props.onConfirmOrder();

    }

    setRetryCount(prev => prev - 1);

  };

  // if (
  //   props.data && // verificăm că props.data nu e undefined
  //   'order' in props.data && // order există în obiect
  //   (props.data.order === null || props.data.order.toString().startsWith('0')) && props.onConfirmOrder
  // ) {

  //   const isMaxRetries = retryCount === 0;

  //   return (
  //     <div className="modal-success-proforma">
  //       <div className="close ">
  //         <IconItem icon={faClose} onClick={() => { props.handleCloseModal(); }} />
  //       </div>
  //       <h1><FontAwesomeIcon icon={faExclamationTriangle} className="icon_try_again" /></h1>
  //       <h1>
  //         {isMaxRetries && !props.loading
  //           ? t('_maximum_retry_exceeded_please_contact_support')
  //           : t('_an_error_occurred_please_try_again')}
  //       </h1>

  //       {
  //         !isMaxRetries && (
  //           <h4>{t('_number_of_attempts')} : {retryCount}</h4>
  //         )
  //       }

  //       <DefaultButton
  //         className="try-again-button"
  //         isloading={props.loading}
  //         disabled={props.loading}
  //         onClick={() => {
  //           if (isMaxRetries) {

  //             props.handleCloseModal();

  //             return;
  //           }

  //           handleRetry();
  //         }}
  //         text={isMaxRetries && !props.loading ? t('_close') : t('_try_again')}
  //       />
  //     </div>
  //   );
  // }


  return (
    <div className="modal-success-proforma">
      {/* <h1>{t('_upload_proforma_successfully')}</h1> */}
      <h1>{t('_submitted_succesfully')}</h1>
      {props.isDirectorCommercial ?
        <div>
          {props.data?.order && (
            props.data?.is_m3_connected ?

              <h2>
                {t('_m3_order')}: {props.data?.order}
              </h2>


              :
              <h2>
                {t('_apl_order')}: {props.data?.order}
              </h2>

          )}
          {(props.data?.aol_order) && (
            <h2>
              {t('_aol_order')}: {props.data?.aol_order}
            </h2>
          )}

          {(props.data?.msg) && (
            <h2>
              {t('_message')}: {t(props.data.msg)}
            </h2>
          )}
        </div>
        : (
          user?.client_settings.m3_erp_connection ?
            <div>
              {props.data?.m3_order && (
                <h2>
                  {t('_m3_order')}: {props.data?.m3_order}
                </h2>
              )}
              {(props.data?.aol_order) && (
                <h2>
                  {t('_aol_order')}: {props.data?.aol_order}
                </h2>
              )}
              {(props.data?.waiting_offer) && (
                <h2>
                  {t('_waiting_offer')}: {props.data.waiting_offer}
                </h2>
              )}
              {props.data?.estimationId && (
                <h2>
                  {t('_order_estimation_id')}: {props.data.estimationId}
                </h2>
              )}
              {(props.data?.msg) && (
                <h2>
                  {t('_message')}: {t(props.data.msg)}
                </h2>
              )}
            </div>
            : (
              <React.Fragment>
                {(props.data?.order || props.data?.proformaId) && (
                  <h2>
                    {t('_order_proforma_id')}: {props.data?.order ?? props.data?.proformaId}
                  </h2>
                )}
                {props.data?.estimationId && (
                  <h2>
                    {t('_order_estimation_id')}: {props.data.estimationId}
                  </h2>
                )}
                {props.data?.proformaId && <h2>{t('_proforma_id')}: {props.data?.proformaId}</h2>}
                {(props.data?.msg) && (
                  <h2>
                    {t('_message')}: {t(props.data.msg)}
                  </h2>
                )}
              </React.Fragment>
            )
        )}
      {props.data?.status === 'PENDING' && (
        <h2 className="order-modal-pending">{t('_order_being_processed')}</h2>
      )}
      <DefaultButton onClick={props.handleCloseModal} text={t('_close')} />
    </div>
  );
};

export default OrderModal;